<template>
  <v-container class="px-2 py-2" fluid v-if="isSearched">
    <v-row dense>
      <v-col>
        <InspIndexDetail :indexDetail="indexDetail" :inspClassCd="enumInspClassCd.APP" />
      </v-col>
    </v-row>
    <v-row dense>
      <v-col>
        <v-form :disabled="!canEdit">
          <validation-observer ref="observer" v-slot="{ invalid }">
            <v-card class="py-2" outlined>
              <v-card-title class="py-0"> {{ $t('ELE0188') }} </v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="4">
                    <v-container class="px-0 py-2">
                      <v-row>
                        <v-col>
                          <DatetimePicker v-model="inspStartDatetime" disableFutureDatetime required />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1">
                          <InspTimingDtlInput
                            v-if="canEdit"
                            v-model="searchResult.inspTimingDtlCd"
                            :companyCatCd="companyCatCd"
                            :inspTimingCd="indexDetail.inspTimingCd"
                            :inspClassCd="enumInspClassCd.APP"
                            :inspCat2Cd="indexDetail.inspCat2Cd"
                            :exceptCdList="exceptInspTimingDtl"
                            required
                          />
                          <InspTimingDtlInput v-else v-model="searchResult.inspTimingDtlCd" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <!--記号入力も許可している-->
                        <v-col class="py-1">
                          <TextFieldInput
                            :label="$t('ELE0157')"
                            v-model="cavComputed"
                            :maxLength="cavLimit"
                            rules="halfWidth"
                            required
                            @change="
                              setNumOfInsp()
                              judgeOverReQty()
                            "
                            v-if="isNew"
                          />
                          <TextFieldRef :label="$t('ELE0157')" :value="cavComputed" v-else />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1">
                          <TextFieldRef :label="$t('ELE0098')" v-model="numOfInspComputed" right />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1">
                          <TextFieldInputWithDatePicker
                            :label="$t('ELE0138')"
                            v-model="searchResult.inspDate"
                            disableFutureDate
                            required
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1">
                          <InspectorInput
                            v-model="searchResult.inspectorCd"
                            :validOnly="canEdit"
                            :disabled="!canEdit"
                            required
                          />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col class="py-1">
                          <TextFieldInput
                            :label="$t('ELE0175')"
                            v-model="searchResult.inspQty"
                            :rules="`rangeNumber:0,${indexDetail.aqlDetermQty}`"
                            required
                            right
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                  <v-col>
                    <v-container fluid fill-height class="px-0 py-0">
                      <v-row>
                        <v-col>
                          <TextAreaInput
                            v-if="canEdit"
                            :label="$t('ELE0054')"
                            v-model="searchResult.remarks"
                            :maxLength="1000"
                          />
                          <TextAreaRef v-else :label="$t('ELE0054')" :value="searchResult.remarks" />
                        </v-col>
                      </v-row>
                      <v-row>
                        <v-col>
                          <BtnAttach :disabled="!fileAttachmentBtnComputed" @click="inspFileAttachDialog = true" />
                        </v-col>
                      </v-row>
                      <v-row align="end">
                        <v-col>
                          <Btn
                            class="mx-2"
                            :label="$t('ELE0186')"
                            :disabled="samplingBoxes.length == 0"
                            @click="samplingBoxDialog = true"
                          />
                          <Btn
                            class="mx-2"
                            :label="$t('ELE0034')"
                            :disabled="!hasInspPoint"
                            @click="inspAttachDialog = true"
                          />
                          <v-badge
                            bordered
                            color="error"
                            icon="mdi-exclamation-thick"
                            overlap
                            :value="canSelectSa && !isConfirmedSa"
                          >
                            <Btn
                              class="mx-2"
                              :label="$t('ELE0383')"
                              :disabled="saItems.length == 0"
                              @click="selectSaDialog = true"
                            />
                          </v-badge>
                        </v-col>
                      </v-row>
                      <v-row></v-row>
                      <v-row align="end">
                        <v-spacer />
                        <v-col class="d-flex justify-end">
                          <Checkbox :label="$t('ELE0189')" v-model="isComplete" />
                        </v-col>
                        <v-col>
                          <SelectSingleInput
                            v-model="searchResult.inspResultCd"
                            :label="$t('ELE0188')"
                            :items="inspStatusItems"
                            itemText="name"
                            itemValue="value"
                            :required="isComplete"
                            :disabled="isInspResultNg"
                          />
                        </v-col>
                      </v-row>
                    </v-container>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0">
                    <v-card outlined class="px-0 py-0">
                      <v-card-title class="pt-0">
                        <v-row dense>
                          <v-col>
                            {{ $t('ELE0185') }}
                          </v-col>
                          <v-col class="d-flex justify-end">
                            <BtnAdd class="mx-2" :disabled="!canEdit" @click="onAddDefect" />
                          </v-col>
                        </v-row>
                      </v-card-title>
                      <v-data-table
                        :headers="headers"
                        :items="appDefects"
                        dense
                        fixed-header
                        disable-pagination
                        hide-default-footer
                        height="200px"
                        mobile-breakpoint="0"
                      >
                        <template v-slot:[`item.action`]="{ index }">
                          <IconDelete :disabled="!canEdit" @click="onDeleteDefect(index)" />
                        </template>
                        <template v-slot:[`item.defectCd`]="{ item, index }">
                          <PartDefectInput
                            :vid="'partDefect_' + index"
                            v-model="item.defectCd"
                            :partCd="indexDetail.partCd"
                            :partRev="searchResult.partRev"
                            :exceptCdList="selectedDefects"
                            :validOnly="canEdit"
                            required
                          />
                        </template>
                        <template v-slot:[`item.defectQty`]="{ item, index }">
                          <TextFieldInput
                            :vid="'defectQty_' + index"
                            label=""
                            v-model="item.defectQty"
                            right
                            :rules="`rangeNumber:1,${indexDetail.lotQty}`"
                            required
                          />
                        </template>
                        <template v-slot:[`item.remarks`]="{ item }">
                          <TextFieldInput label="" v-model="item.remarks" :maxLength="1000" />
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row>
                  <v-spacer />
                  <v-col class="d-flex justify-end">
                    <BtnDelete
                      class="mx-2"
                      :label="$t('ELE0036')"
                      :disabled="!canDelete"
                      @click="confirmDialog = true"
                    />
                    <BtnSave :label="$t('ELE0019')" :disabled="invalid || !canEdit" @click="onClickSave" />
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </validation-observer>
        </v-form>
      </v-col>
    </v-row>

    <v-dialog v-if="inspAttachDialog" v-model="inspAttachDialog" scrollable>
      <v-card>
        <v-card-title class="primary white--text py-2">
          {{ $t('ELE0191') }}
          <v-spacer />
          <Btn icon="mdi-close" @click="inspAttachDialog = false" depressed iconProp color="white" />
        </v-card-title>
        <v-card-text>
          <InspAttachmentForm :partCd="indexDetail.partCd" isInquiry />
        </v-card-text>
      </v-card>
    </v-dialog>

    <SearchBoxSamplingDialog
      :dialog.sync="samplingBoxDialog"
      :inspIndexNo="searchResult.inspIndexNo"
      :cav="cavComputed"
      :numOfInsp="numOfInspComputed"
      :boxes="samplingBoxes"
    />

    <DelConfirmDialog
      :dialog="confirmDialog"
      :confirmWord="$t('MSG0013')"
      :btnLabel="$t('ELE0036')"
      @cancel="confirmDialog = false"
      @proceed="onProceedDelete"
    />

    <NumConfirmDialog
      :dialog="numConfirmDialog"
      :confirmWord="$t('MSG0086', { p0: this.cavComputed })"
      :confirmLastWord="$t('MSG0087')"
      :btnLabel="$t('ELE0019')"
      @cancel="numConfirmDialog = false"
      @proceed="onProceedSave"
    />

    <SelectSaDialog
      :dialog.sync="selectSaDialog"
      :propsItems="saItems"
      :disabled="!canSelectSa"
      @close="isConfirmedSa = true"
      @set="applySa"
    />
    <div v-if="inspFileAttachDialog">
      <InspectionFileAttachmentDialog
        :dialog.sync="inspFileAttachDialog"
        :headerTitle="$t('ELE0211')"
        :attachedFiles="attachedFilesComputed"
        :isInquiry="!canEdit"
        :inspIndexNo="searchResult.inspIndexNo"
        :cav="cavComputed"
        :numOfInsp="numOfInspComputed"
        @set="onSetAttachedFiles"
      />
    </div>
  </v-container>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import { API } from '@/plugins/api'
import { Storage } from '@/plugins/storage'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'
import Loading from '@/mixin/loading-utils.js'
import DateUtil from '@/mixin/date-utils.js'
import CheckUtil from '@/mixin/check-utils.js'

import {
  InspStatusCd,
  InspResultCd,
  InspClassCd,
  SystemParameterKey,
  OqcIqcCd,
  InspectionTimingDtl,
  S3Root,
} from '@/enum'
import moment from 'moment'
import BigNumber from 'bignumber.js'

import Btn from '@/components/atoms/base/button/Btn.vue'
import BtnAttach from '@/components/atoms/button/BtnAttach.vue'
import BtnSearch from '@/components/atoms/button/BtnSearch'
import BtnAdd from '@/components/atoms/button/BtnAdd'
import BtnDelete from '@/components/atoms/button/BtnDelete'
import BtnSave from '@/components/atoms/button/BtnSave'
import TextFieldInput from '@/components/atoms/base/text-field/TextFieldInput'
import TextFieldRef from '@/components/atoms/base/text-field/TextFieldRef'
import TextAreaInput from '@/components/atoms/base/text-field/TextAreaInput'
import TextAreaRef from '@/components/atoms/base/text-field/TextAreaRef'
import TextFieldInputWithDatePicker from '@/components/atoms/base/text-field/TextFieldInputWithDatePicker'
import Checkbox from '@/components/atoms/base/checkbox/Checkbox'
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import IconDelete from '@/components/atoms/icon/IconDelete'

import SearchBoxSamplingDialog from '@/components/organisms/terminal/dialog/SearchBoxSamplingDialog'
import InspAttachmentForm from '@/components/organisms/master/form/InspAttachmentForm'
import InspIndexDetail from '@/components/organisms/terminal/card/InspIndexDetail'
import InspectorInput from '@/components/atoms/select/InspectorInput'
import PartDefectInput from '@/components/atoms/select/PartDefectInput'
import DelConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog'
import NumConfirmDialog from '@/components/organisms/common/dialog/ConfirmDialog'
import InspectionFileAttachmentDialog from '@/components/organisms/terminal/dialog/InspectionFileAttachmentDialog'
import DatetimePicker from '@/components/atoms/text-field/DatetimePicker'
import SelectSaDialog from '@/components/organisms/terminal/dialog/SelectSaDialog'
import InspTimingDtlInput from '@/components/atoms/select/InspTimingDtlInput'

export default {
  name: 'InputAppInspForm',

  mixins: [APIUtils, Message, Loading, DateUtil, CheckUtil],

  components: {
    ValidationObserver,
    Btn,
    BtnSearch,
    BtnAdd,
    BtnDelete,
    BtnSave,
    TextFieldInput,
    TextFieldRef,
    TextAreaInput,
    TextAreaRef,
    TextFieldInputWithDatePicker,
    Checkbox,
    SelectSingleInput,
    IconDelete,
    SearchBoxSamplingDialog,
    InspAttachmentForm,
    InspIndexDetail,
    PartDefectInput,
    InspectorInput,
    DelConfirmDialog,
    NumConfirmDialog,
    DatetimePicker,
    SelectSaDialog,
    InspTimingDtlInput,
    BtnAttach,
    InspectionFileAttachmentDialog,
  },

  props: {
    inspIndexNo: {
      type: String,
      required: true,
    },
    cav: {
      type: String,
      required: true,
    },
    numOfInsp: {
      type: Number,
      required: false,
      default: null,
    },
  },

  data() {
    return {
      companyCatCd: this.$store.getters.companyCatCd,
      isSearched: false,
      isNew: false,
      samplingBoxDialog: false,
      inspAttachDialog: false,
      confirmDialog: false,
      numConfirmDialog: false,
      selectSaDialog: false,
      isConfirmedSa: true,
      manufacturerData: null,
      canOutgoingInsp: false,
      existsInspTimingConst: false,
      inspFileAttachDialog: false,
      attachedFiles: [],
      headers: [
        { text: '', value: 'action', align: 'center', divider: true, sortable: false, width: '50' },
        {
          text: this.$t('ELE0011'),
          value: 'defectCd',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
          width: '400',
        },
        {
          text: this.$t('ELE0174'),
          value: 'defectQty',
          align: 'right',
          divider: true,
          sortable: false,
          cellClass: 'py-1',
          width: '200',
        },
        { text: this.$t('ELE0054'), value: 'remarks', sortable: false, cellClass: 'py-1' },
      ],
      searchResult: {
        inspTimingDtlCd: '',
        numOfInsp: null,
        inspDate: '',
        inspectorCd: '',
        inspQty: null,
        inspResultCd: '',
        partRev: null,
        remarks: '',
        defects: [],
        isMaxNum: false, // 表示中の検査回数がDB上のMAX値である
      },
      indexDetail: null,
      cavAppDefects: [],
      isInspResultNg: false,
      isComplete: false,
      inspStartDatetime: '',
      samplingBoxes: [],
      hasInspPoint: false,
      saItems: [],
      cavLimit: 10,
    }
  },

  computed: {
    enumInspClassCd: () => InspClassCd,
    canEdit: {
      // Formの編集可否判定
      get() {
        let result = false
        if (!this.isSearched) {
          result = false
          // 編集モード、かつ最新でない検査回数を表示中
        } else if (!this.isNew && !this.searchResult.isMaxNum) {
          result = false
          // 検査可能な検査状態か
        } else if (
          this.indexDetail.inspStatusCd != InspStatusCd.WAITING_FOR &&
          this.indexDetail.inspStatusCd != InspStatusCd.IN_PROGRESS
        ) {
          result = false
          // 検査タイミング詳細に登録されているか
        } else if (!this.existsInspTimingConst) {
          result = false
        } else {
          result = this.canInspCompany || this.canSrcInsp
        }
        return result
      },
    },
    canInspCompany: {
      get() {
        let result = false
        // ユーザーが検査可能な検査インデックスか
        if (!this.isInspectableCompany(this.indexDetail.inspCompanyCd, this.indexDetail.inspCompanyCatCd)) {
          result = false
        } else {
          result = true
        }
        return result
      },
    },
    canSrcInsp: {
      get() {
        let result = false
        if (
          this.$store.getters.isEpson &&
          this.manufacturerData &&
          this.manufacturerData.companyCatCd == OqcIqcCd.OQC &&
          this.manufacturerData.isSrcInsp
        ) {
          result = true
        }
        return result
      },
    },
    canDelete: {
      // 検査結果の削除可否判定
      get() {
        return !this.isNew && this.canEdit
      },
    },
    inspIndexNoComputed: {
      get() {
        return this.inspIndexNo
      },
      set(value) {
        this.$emit('update:inspIndexNo', value)
      },
    },
    cavComputed: {
      get() {
        return this.cav
      },
      set(value) {
        this.$emit('update:cav', value)
      },
    },
    numOfInspComputed: {
      get() {
        return this.numOfInsp
      },
      set(value) {
        this.$emit('update:numOfInsp', value)
      },
    },
    selectedDefects: {
      // 不良プルダウンで選択済みの値リスト
      get() {
        let items = []
        for (let idx = 0; idx < this.appDefects.length; idx++) {
          const defect = this.appDefects[idx]
          items.push({ defectCd: defect.defectCd })
        }
        return items
      },
    },
    inspStatusItems: {
      get() {
        // プルダウン選択肢をenumから生成
        return Object.values(InspResultCd).map((item) => {
          return { name: item + ' : ' + this.$t(`InspResultCd.${item}`), value: item }
        })
      },
    },
    appDefects: {
      get() {
        return this.searchResult.defects
      },
    },
    totalAppDefectQty: {
      get() {
        let totalQty = BigNumber(0)
        for (let idx = 0; idx < this.appDefects.length; idx++) {
          const qty = this.appDefects[idx].defectQty
          if (!isNaN(qty)) {
            totalQty = BigNumber(qty).plus(totalQty)
          }
        }
        return totalQty
      },
    },
    canSelectSa: {
      get() {
        let result = false
        if (this.canEdit && this.isNew && this.saItems.length > 0) {
          result = true
        }
        return result
      },
    },
    selectedSaNoList: {
      get() {
        let saNolist = []
        this.saItems.forEach((el) => {
          if (el.isSelected) {
            saNolist.push(el.saNo)
          }
        })
        return saNolist
      },
    },
    exceptInspTimingDtl: {
      get() {
        let result = [{ inspTimingDtlCd: InspectionTimingDtl.OUTGOING }]
        if (this.canOutgoingInsp) {
          // Outgoing検査が可能な場合、除外リストからOutgoingを削除する
          result = []
        }
        return result
      },
    },
    fileAttachmentBtnComputed: {
      get() {
        return this.inspIndexNoComputed && this.cavComputed && this.numOfInspComputed
      },
    },
    attachedFilesComputed: {
      get() {
        return this.attachedFiles
      },
    },
  },

  watch: {
    inspIndexNoComputed: {
      async handler(value) {
        if (value) {
          await this.setSaInInsp()
          await this.search(this.inspIndexNoComputed, this.cavComputed, this.numOfInspComputed)

          if (this.isNew) {
            this.isConfirmedSa = this.saItems.length > 0 ? false : true
          } else if (this.indexDetail != null && this.indexDetail.saNoList.length > 0) {
            await this.setSaInInsp()
          }
        } else {
          this.isSearched = false
        }
      },
      immediate: true,
    },
    appDefects: {
      handler() {
        this.judgeOverReQty()
      },
      deep: true,
    },
    numOfInspComputed: {
      handler(value) {
        if (value) {
          this.setAttachedFiles(value)
        }
      },
    },
  },

  methods: {
    async setSaInInsp() {
      try {
        this.saItems = await API.get('/sa/insp', {
          inspClassCd: InspClassCd.APP,
          inspIndexNo: this.inspIndexNoComputed,
          saNoList: this.indexDetail == null ? [] : this.indexDetail.saNoList,
        })
      } catch (error) {
        this.saItems = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0291') })))
      }
    },

    applySa(items) {
      this.isConfirmedSa = true
      this.saItems = items

      this.searchResult.saList = this.selectedSaNoList
      let indexDetail = this.indexDetail
      indexDetail.saNoList = this.searchResult.saList
      this.indexDetail = indexDetail
    },

    async search(inspIndexNo, cav, numOfInsp) {
      try {
        this.startLoading()

        this.searchResult = await API.get('/inspApp', {
          inspIndexNo: inspIndexNo,
          cav: cav,
          numOfInsp: numOfInsp,
          saNoList: this.selectedSaNoList,
        })

        this.numOfInspComputed = this.searchResult.numOfInsp
        this.searchResult.inspDate = this.searchResult.inspDate
          ? this.searchResult.inspDate
          : moment().format('YYYY-MM-DD')
        this.searchResult.inspectorCd = this.searchResult.inspectorCd
          ? this.searchResult.inspectorCd
          : this.$store.getters.userCd

        this.cavAppDefects = await API.get('/inspApp/defectsCav', { inspIndexNo: inspIndexNo })
        this.getSourceInsp(inspIndexNo)
        this.manufacturerData = await this.getManufacturerData(this.searchResult.manufacturerCd)

        let param = {
          partRev: this.searchResult.partRev,
        }
        if (
          (!this.searchResult.inspTimingDtlCd && this.canSrcInsp) ||
          this.searchResult.inspTimingDtlCd == InspectionTimingDtl.SOURCE
        ) {
          param.filteringInspTimingCd = OqcIqcCd.IQC
        }

        const indexDetail = await API.get('/inspIndex/inspIndexes/' + this.inspIndexNoComputed + '/lot', param)
        indexDetail.saNoList = this.searchResult.saList
        this.indexDetail = indexDetail

        this.samplingBoxes = await this.searchBoxSampling(
          indexDetail.inspTimingCd,
          indexDetail.manufacturerCd,
          indexDetail.partCd,
          indexDetail.lotNo,
        )
        this.hasInspPoint = await this.existsPartInspPoints(indexDetail.partCd)

        const inspTimingConst = await this.getInspTimingConst()
        if (inspTimingConst.length) {
          this.existsInspTimingConst = true
        }

        if (this.numOfInspComputed) {
          this.isNew = false
        } else {
          this.isNew = true
        }

        if (indexDetail.inspStartDatetime == null) {
          this.inspStartDatetime = moment().format('YYYY-MM-DD HH:mm:00')
        } else {
          this.inspStartDatetime = this.toLocalTime(indexDetail.inspStartDatetime)
        }

        this.isComplete = false
        this.isSearched = true
        this.judgeOverReQty()

        if (this.searchResult.appAttachmentList?.length > 0) {
          this.onSetAttachedFiles(this.searchResult.appAttachmentList)
        }
      } catch (error) {
        this.isSearched = false
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0118') })))
      } finally {
        this.stopLoading()
      }
    },

    judgeOverReQty() {
      // AQLマスタのReQty以上の不良が出ているか判定
      this.isInspResultNg = false
      const cav = this.cavComputed

      if (this.canEdit && cav != '') {
        // 画面表示中のcavの外観不良数合計
        let totalQty = this.totalAppDefectQty

        this.cavAppDefects.forEach((defect) => {
          // 画面表示していないcavの外観不良数を足す
          if (cav != defect.cav) {
            totalQty = BigNumber(totalQty).plus(defect.defectQty)
          }
        })

        if (BigNumber(totalQty).gte(BigNumber(this.indexDetail.reQty))) {
          this.isInspResultNg = true
          this.searchResult.inspResultCd = InspResultCd.NG
        }
      }
    },

    async setNumOfInsp() {
      try {
        this.startLoading()

        if (this.cavComputed) {
          const maxNumOfInsp = await API.get('/inspApp/maxNumOfInsp', {
            inspIndexNo: this.inspIndexNoComputed,
            cav: this.cavComputed,
          })

          if (maxNumOfInsp) {
            this.numOfInspComputed = maxNumOfInsp + 1
          } else {
            this.numOfInspComputed = 1
          }
        } else {
          this.numOfInspComputed = null
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0098') })))
      } finally {
        this.stopLoading()
      }
    },

    async setAttachedFiles() {
      try {
        this.startLoading()

        if (this.cavComputed) {
          const appAttachmentFiles = await API.get('/inspApp/inspAttachment', {
            inspIndexNo: this.inspIndexNoComputed,
            cav: this.cavComputed,
            numOfInsp: this.numOfInspComputed,
          })

          if (appAttachmentFiles?.length > 0) {
            this.onSetAttachedFiles(appAttachmentFiles)
          }
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0527') })))
      } finally {
        this.stopLoading()
      }
    },

    isNewNumOfInsp() {
      // 2以上の検査回数で検査データを登録しようとしているか判定
      let result = false
      if (this.isNew && this.numOfInspComputed > 1) {
        result = true
      }
      return result
    },

    async onClickSave() {
      // 保存
      try {
        this.startLoading()

        if (await this.validate()) {
          await this.save()
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0158') })))
      } finally {
        this.stopLoading()
      }
    },

    async validate() {
      // 入力チェック
      if (!(await this.$refs.observer.validate())) {
        return false
      }

      if (!this.validateDefectQty()) {
        return false
      }

      if (this.isNewNumOfInsp()) {
        this.numConfirmDialog = true
        return false
      }

      return true
    },

    validateDefectQty() {
      // 外観不良合計が検査数を超えていないかチェック
      let result = true

      if (BigNumber(this.totalAppDefectQty).gt(BigNumber(this.searchResult.inspQty))) {
        result = false
        this.setErrorMessage(this.$t('MSG0077'))
      }

      return result
    },

    async onProceedSave() {
      // 保存
      try {
        this.startLoading()
        this.numConfirmDialog = false
        await this.save()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0003', { p0: this.$t('ELE0159') })))
      } finally {
        this.stopLoading()
      }
    },

    async save() {
      // 保存
      await this.uploadAttachedFile()
      const body = {
        inspIndexNo: this.searchResult.inspIndexNo,
        cav: this.cavComputed,
        inspTimingDtlCd: this.searchResult.inspTimingDtlCd,
        numOfInsp: this.numOfInspComputed,
        inspDate: this.searchResult.inspDate,
        inspectorCd: this.searchResult.inspectorCd,
        inspQty: this.searchResult.inspQty,
        inspResultCd: this.searchResult.inspResultCd,
        partRev: this.searchResult.partRev,
        remarks: this.searchResult.remarks,
        defects: this.appDefects,
        saNoList: this.searchResult.saList,
        versionNo: this.indexDetail.versionNo,
        isComplete: this.isComplete,
        inspStartDatetime: this.toServerTime(this.inspStartDatetime),
        appAttachmentList: this.attachedFiles,
      }

      await API.post('/inspApp/register', body)

      this.setSuccessMessage(this.$t('MSG0011', { p0: this.$t('ELE0158') }))
      this.resetForm()
    },

    async onProceedDelete() {
      // 削除
      try {
        this.startLoading()

        const body = {
          inspIndexNo: this.searchResult.inspIndexNo,
          cav: this.cavComputed,
          numOfInsp: this.numOfInspComputed,
          versionNo: this.indexDetail.versionNo,
        }

        await API.post('/inspApp/delete', body)

        this.setSuccessMessage(this.$t('MSG0014'))
        this.resetForm()
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0004', { p0: this.$t('ELE0158') })))
      } finally {
        this.stopLoading()
      }
    },

    resetForm() {
      this.isSearched = false
      this.$emit('reset')
    },

    onAddDefect() {
      // 不良入力行を新規追加
      const item = {
        defectCd: '',
        defectQty: null,
        remarks: '',
      }
      this.appDefects.push(item)
    },

    onDeleteDefect(index) {
      // 不良入力行を削除
      this.appDefects.splice(index, 1)
    },

    async searchBoxSampling(inspTimingCd, manufacturerCd, partCd, lotNo) {
      // サンプリング検査箱取得
      let boxes = []

      try {
        const params = {
          inspTimingCd: inspTimingCd,
          manufacturerCd: manufacturerCd,
          partCd: partCd,
          lotNo: lotNo,
        }
        boxes = await API.get('/box/sampling/lot', params)
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0186') })))
      }

      return boxes
    },

    async existsPartInspPoints(partCd) {
      // 検査添付ファイルマスタの存在チェック
      let hasInspPoint = false

      try {
        const params = {
          partCd: partCd,
        }
        const inspPoints = await API.get('/master/partInspPoints', params)

        if (inspPoints.length > 0) {
          hasInspPoint = true
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0034') })))
      }

      return hasInspPoint
    },

    async uploadAttachedFile() {
      for (let index = 0; index < this.attachedFiles.length; index++) {
        this.attachedFiles[index].dtlNo = index + 1
        if (!this.attachedFiles[index].filePath) {
          this.attachedFiles[index].filePath = await Storage.uploadFile(
            this.attachedFiles[index].file,
            'insp/' + this.inspIndexNo + '/' + S3Root.INSP_APP,
          )
          this.attachedFiles[index].file = null
        }
      }
    },

    onSetAttachedFiles(fileList) {
      this.attachedFiles = fileList.map((element) => {
        if (!element.filename) {
          return {
            ...element,
            filename: element.filePath.split('/').pop(),
          }
        }
        return element
      })
    },

    async setParameter() {
      try {
        const param = await API.get(`/master/systemParameter/${SystemParameterKey.INSP_CAV_LIMIT}`)
        if (param) {
          this.cavLimit = Number(param.value) > 0 ? Number(param.value) : 10
        }
      } catch (error) {
        this.cavLimit = 10
        if (error.response.status != 404) {
          this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0348') })))
        }
      }
    },
    async getInspTimingConst() {
      let result = []
      try {
        let params = {
          companyCatCd: this.$store.getters.companyCatCd,
          inspTimingCd: this.indexDetail.inspTimingCd,
          inspClassCd: InspClassCd.APP,
          inspCat2: this.indexDetail.inspCat2Cd,
        }
        if (!this.isNew) params.inspTimingDtlCd = this.searchResult.inspTimingDtlCd
        result = await API.get('/master/inspTimingConstraints', params)
      } catch (error) {
        result = []
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
      }
      return result
    },
    async getManufacturerData(manufacturerCd) {
      let result = null
      try {
        result = await API.get(`/master/companies/${manufacturerCd}`)
      } catch (error) {
        result = null
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0002') })))
      }
      return result
    },
    async getSourceInsp(inspIndexNo) {
      try {
        let params = {
          inspIndexNoList: [inspIndexNo],
          inspTimingDtlCd: InspectionTimingDtl.SOURCE,
        }
        const elements = await API.get('/inspIndex/apps/inspResults', params)
        this.canOutgoingInsp = elements.every(
          (e) => e.inspResultCd == InspResultCd.OK || e.inspResultCd == InspResultCd.SA_OK,
        )
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0211') })))
      }
    },
  },
  async mounted() {
    await this.setParameter()
  },
}
</script>
